import { ChangeHighlighter, FormattedNumberInput } from '@rd-web-markets/shared/dist/util';
import React from 'react'
import { Card, Table, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import './personnelFramework.css'

const PersonnelFramework = ({personnelFrameworks, report, handlePersonnelFrameworkChange, saveChange, frameworkFirstColumnStyle, loading}) => {
  const years = personnelFrameworks.map(a => a.year);
    const { t } = useTranslation();
  
  return (
 
    <Card>
      <Card.Header>
        {t('personnel_framework')}{loading && ` (${t('loading')}...)`}
      </Card.Header>
      <Card.Body>
        <Table  style={{ tableLayout: 'fixed'}} hover>
          <thead>
            <tr>
              <th style={frameworkFirstColumnStyle}></th>
              {years.sort().map(year => {
                return <th className="text-center">{year}</th>
              })}
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{width: '41%'}}>{t('personnel_framework_of_the_project_total')}</td>
              {personnelFrameworks.map((framework, index) => { 
                return (
                  <td key={index}>
                    <ChangeHighlighter
                      as={FormattedNumberInput}
                      thousandSeparator="."
                      decimalSeparator=","
                      object={framework}
                      name="total"
                      type="text"
                      size="sm"
                      onlyPositiveNumbers={true}
                      disabled={true}
                    />
                  </td>
                )
              })}
            </tr>
            <tr>
              <td style={{width: '41%'}}>{t('personnel_framework_of_the_project_scientists_staf_with_technical_degree_in_manmonths')}</td>
              {personnelFrameworks.map((framework, index) => { 
                return (
                  <td key={index}>
                    <ChangeHighlighter
                      as={FormattedNumberInput}
                      thousandSeparator="."
                      decimalSeparator=","
                      onChange={(e) => handlePersonnelFrameworkChange(e, index)}
                      onBlur={() => saveChange(index, 'personnel')}
                      object={framework}
                      name="scientists_staff"
                      type="text"
                      size="sm"
                      onlyPositiveNumbers={true}
                      disabled={report.application_submitted || loading}
                    />
                  </td>
                )
              })}
            </tr>
            <tr>
              <td style={{width: '41%'}}>{t('personnel_framework_of_the_project_technicians_in_manmonths')}</td>
              {personnelFrameworks.map((framework, index) => { 
                return (
                  <td key={index}>
                    <ChangeHighlighter
                      as={FormattedNumberInput}
                      thousandSeparator="."
                      decimalSeparator=","
                      onChange={(e) => handlePersonnelFrameworkChange(e, index)}
                      onBlur={() => saveChange(index, 'personnel')}
                      object={framework}
                      name="technicians"
                      type="text"
                      size="sm"
                      onlyPositiveNumbers={true}
                      disabled={report.application_submitted || loading}
                    />
                  </td>
                )
              })}
            </tr>
            <tr>
              <td style={{width: '41%'}}>{t('personnel_framework_of_the_project_others_in_manmonths')}</td>
              {personnelFrameworks.map((framework, index) => { 
                return (
                  <td key={index}>
                    <ChangeHighlighter
                      as={FormattedNumberInput}
                      thousandSeparator="."
                      decimalSeparator=","
                      onChange={(e) => handlePersonnelFrameworkChange(e, index)}
                      onBlur={() => saveChange(index, 'personnel')}
                      object={framework}
                      name="others"
                      type="text"
                      size="sm"
                      onlyPositiveNumbers={true}
                      disabled={report.application_submitted || loading}
                    />
                  </td>
                )
              })}
            </tr>


            <tr>
              <td style={{width: '41%'}}>{t('personal_contribution_in_hours')}</td>
              {personnelFrameworks.map((framework, index) => { 
                const frameworkWithDefault = {
                  ...framework,
                  personal_contribution_in_hours: framework.personal_contribution_in_hours ?? 0
                };
                return (
                  <td key={index}>
                    <ChangeHighlighter
                      as={Form.Control}
                      onChange={(e) => handlePersonnelFrameworkChange(e, index)}
                      onBlur={() => saveChange(index, 'personnel')}
                      object={frameworkWithDefault}
                      name="personal_contribution_in_hours"
                      type="number"
                      step="1"
                      min="0"
                      size="sm"
                      disabled={report.application_submitted || loading}
                    />
                  </td>
                )
              })}
            </tr>
            <tr>
              <td style={{width: '41%'}}><p style={{inlineSize: '100%'}}>{t('wereare_the_personnel_expenses_andor_contract_costs_for_contracts_within_the_eueea_for_this_rd_project_funded_within_the_framework_of_other_funding_or_state_aid')}</p></td>
              {personnelFrameworks.map((framework, index) => { 
                return (
                  <td key={index}>
                    <Form.Control
                      onChange={async (e) => {
                        await handlePersonnelFrameworkChange(e, index);
                        saveChange(index, 'personnel')
                      }}
                      name="funded_from_eu"
                      value={framework.funded_from_eu}
                      size="sm"
                      as="select"
                      disabled={report.application_submitted || loading}
                    >
                      <option value={true}>{t('yes')}</option>
                      <option value={false}>{t('no')}</option>
                    </Form.Control>
                  </td>
                )
              })}
            </tr>
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  )
}

export default PersonnelFramework
